import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { RightsService, UpdateRightsParams } from 'src/Services/API';

import { MutationKeys, QueryKeys } from '../types';

export const useUpdateRights = () => {
  const queryClient = useQueryClient();

  return useMutation(
    [MutationKeys.updateRights],
    async (params: UpdateRightsParams) => {
      return await RightsService.rightsControllerUpdateRights({ body: params });
    },
    {
      onSuccess: () => {
        toast.success('les droits du collaborateur ont été modifiés');
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchRights] });
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchUserUnitaryRights] });
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchAuthorizedModifiedProfiles] });
      },
      onError: (error: AxiosError) => {
        switch (error.response?.status) {
          case 403:
            toast.error('droits insuffisants pour modifier les droits de ce collaborateur');
            break;
          case 409:
            toast.error('vous ne pouvez pas modifier le dernier superadmin');
            break;
          default:
            toast.error('erreur lors de la modification des droits');
            break;
        }
      },
    }
  );
};
